define([], () => {
    return {
        getInitializedPartnerDetails(productCode, subproductInputParam, employeeMode) {
            if (/^Partner(Direct|Leasing)Motorfahrzeug$/i.test(productCode)) {
                const isPartnerLeasingProduct = /Leasing/i.test(productCode);
                const isLeaseplanSubproductInputParam = /leaseplan/i.test(subproductInputParam);

                // Caution: Changes to the logic will also affect the display of the Riskrelevant Data Page
                // (for example isLeaseplanSubproductInputParam should display only the email inputfield).
                return {
                    isCreatedByDealer: (isPartnerLeasingProduct && !isLeaseplanSubproductInputParam),
                    isSelectedDealer: !(isPartnerLeasingProduct && isLeaseplanSubproductInputParam),
                    dealerContact: (isPartnerLeasingProduct && isLeaseplanSubproductInputParam) ? undefined : {},
                    dealerIsEmployer: !!employeeMode,
                };
            } else {
                return undefined;
            }
        },
    };
});




// WEBPACK FOOTER //
// ../common/js/src/edge/platform/basler/util/MFPPartnerUtil.js